import { createSelector } from '@reduxjs/toolkit';
import { groupBy } from 'es-toolkit/compat';
import { RootState } from '../../configureStore';

export const unitTemplatesSelector = ({ entities }: RootState) => {
  return entities.unitTemplates;
};

export const getUnitTemplateConfigurationSelector = createSelector(
  unitTemplatesSelector,
  (unitTemplates) => {
    return unitTemplates?.configuration;
  },
);

export const getActiveUnitTemplateSelector = createSelector(
  unitTemplatesSelector,
  (unitTemplates) => {
    return unitTemplates?.configuration?.reduce((acc, { quantity, unit }) => {
      return { ...acc, [quantity]: unit };
    }, {});
  },
);

export const getUnitTemplateLoadingSelector = createSelector(
  unitTemplatesSelector,
  (unitTemplates) => {
    return unitTemplates?.isLoading;
  },
);

export const getUnitTemplateQuantitiesGroupedSelector = createSelector(
  unitTemplatesSelector,
  ({ configuration }) => {
    const groupedConfiguration = groupBy(configuration, 'quantity');
    return groupedConfiguration;
  },
);
